import * as xmldsigjs from "xmldsigjs";
import {ethers} from "ethers";
import {EthersCrypto, EthersCryptoKey} from "./ethersSubtleCryptoProvider";
import * as x509 from "@peculiar/x509";

function getEthersProvider(){
    return new ethers.BrowserProvider(window.ethereum);
}

const crypto = new EthersCrypto(await getEthersProvider().getSigner());

xmldsigjs.Application.setEngine("OpenSSL", <Crypto> crypto);

const TEST_XML = `<ts:token xmlns:ethereum="urn:ethereum:constantinople" xmlns:ts="http://tokenscript.org/2022/09/tokenscript" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" name="Test" xsi:schemaLocation="http://tokenscript.org/2022/09/tokenscript https://tokenscript.org/2022/09/tokenscript.xsd">
	<ts:label>
		<ts:plurals xml:lang="en">
			<ts:string quantity="one">Test Token</ts:string>
			<ts:string quantity="other">Test Tokens</ts:string>
		</ts:plurals>
	</ts:label>
	<ts:meta>
		<ts:description xml:lang="en">Test</ts:description>
		<ts:aboutUrl xml:lang="en">Test</ts:aboutUrl>
		<ts:iconUrl xml:lang="en">Test</ts:iconUrl>
	</ts:meta>
	<ts:contract interface="erc721" name="Token">
		<ts:address network="137">0xD5cA946AC1c1F24Eb26dae9e1A53ba6a02bd97Fe</ts:address>
	</ts:contract>
	<ts:origins>
		<ts:ethereum contract="Token"/>
	</ts:origins>
	<ts:cards>
		<ts:card name="Info" type="token">
			<ts:label>
				<ts:string xml:lang="en">Info</ts:string>
			</ts:label>
			<ts:view xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">
				
			</ts:view>
		</ts:card>
	</ts:cards>
</ts:token>`;

class XmlSigner {

    private signedXmlString;
    private publicKey: CryptoKey;

    public async signTestXml(){
        return this.executeXmlSigning(TEST_XML);
    }

    public async signXml(){
        // Get xml string
        const xmlFile = (document.getElementById("xml-file") as HTMLInputElement).files.item(0);

        if (!xmlFile){
            alert("Please select an TSML file first");
            return;
        }

        const xmlStr = await xmlFile.text();

        // Get certificate string
        const certFile = (document.getElementById("certificate-file") as HTMLInputElement).files.item(0);

        const certificateStr = certFile ? await certFile.text() : undefined;

        await this.executeXmlSigning(xmlStr, certificateStr);
    }

    private async getPublicKey(){

        const signer = await getEthersProvider().getSigner();

        const message = "Recovering Public Key";
        const sig = await signer.signMessage(message);

        const hash = ethers.toBeArray(ethers.hashMessage(message));
        const recoveredKey = ethers.SigningKey.recoverPublicKey(hash, sig);

        return new EthersCryptoKey("public", recoveredKey);
    }

    private async executeXmlSigning(xmlStr: string, certificateStr?: string){

        const unsignedXml = xmldsigjs.Parse(xmlStr);

        const xml = new xmldsigjs.SignedXml(unsignedXml);

        let certs;

        if (certificateStr){
            const rawCert = x509.PemConverter.decodeFirst(certificateStr);
            const certBase64 = ethers.encodeBase64(new Uint8Array(rawCert));
            certs = [certBase64];
        }

        this.publicKey = await this.getPublicKey();

        const signature = await xml.Sign(
            {name: "ECDSA", hash: "SHA-256"},
            new EthersCryptoKey("private"),
            //keyPair.privateKey!!,
            unsignedXml,
            {                                                     // options
                keyValue: this.publicKey,
                references: [
                    {hash: "SHA-256", transforms: ["enveloped", "c14n"]},
                ],
                x509: certs
            }
        );

        this.signedXmlString = xml.toString();
        document.getElementById("xml-output").innerText = this.signedXmlString;

        return signature;
    }

    public async validateXml(){

        if (!this.signedXmlString)
            return alert("Sign an XML first!");

        let doc = xmldsigjs.Parse(this.signedXmlString);
        let signature = doc.getElementsByTagNameNS("http://www.w3.org/2000/09/xmldsig#", "Signature");

        const xml = new xmldsigjs.SignedXml(doc);

        xml.LoadXml(signature[0]);

        let verified = await xml.Verify(this.publicKey);

        if (verified){
            alert("TSML signature successfully verified!");
        } else {
            alert("TSML signature verification failed :-(");
        }
    }

    public downloadXml(){

        if (!this.signedXmlString)
            return alert("Sign an XML first!");

        var element = document.createElement('a');
        element.setAttribute('href', 'data:application/xml;charset=utf-8,' + encodeURIComponent(this.signedXmlString));
        element.setAttribute('download', "tokenscript.signed.tsml");

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }
}

declare global {
    interface Window {
        xmlSigner: XmlSigner
        ethereum: any
    }
}

window.xmlSigner = new XmlSigner();